import { useMemo } from "react";

import { CodeEditor } from "components/elements";
import {
  Subsection,
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from "components/layout";
import { TiVoLaunchAttributes, URL_PARAMETER_PLACEMENT } from "hooks/tivoApps";
import { NO_VALUE_PLACEHOLDER } from "src/constants";

import { toJsonString } from "../../utils";
import { TEXTS } from "../constants";
import styles from "./LaunchAttrsSection.scss";
import { SubsectionWithFallback } from "./SubsectionWithFallback";
import { SubsectionWithLink } from "./SubsectionWithLink";
import { TechnicalText } from "./TechnicalText";

export type LaunchAttrsUriTabProps = {
  attributes: TiVoLaunchAttributes;
};

export function LaunchAttrsUriTab({ attributes }: LaunchAttrsUriTabProps) {
  const attributesWithCriteria = useMemo(
    () => toJsonString(attributes.attributesWithCriteria || undefined),
    [attributes.attributesWithCriteria]
  );

  return (
    <>
      <SubsectionWithLink
        header={TEXTS.VARIANT.PLAYBACK_URI_SUBS_HEADER}
        href={attributes.playbackUri}
      />
      <Subsection header={TEXTS.VARIANT.AD_PARAMS_TEMPLATE_SUBS_HEADER}>
        <TechnicalText>{attributes.adParamsTemplate}</TechnicalText>
      </Subsection>
      <SubsectionWithFallback
        header={TEXTS.VARIANT.APPEND_URL_PARAMS_SUBS_HEADER}
        value={attributes.appendUrlParameters}
      >
        {(rows) => (
          <Table>
            <TableHeader>
              {[
                TEXTS.VARIANT.NAME_COL_HEADER,
                TEXTS.VARIANT.KEY_COL_HEADER,
                TEXTS.VARIANT.VALUE_COL_HEADER,
                TEXTS.VARIANT.PLACEMENT_COL_HEADER,
              ].map((header) => (
                <TableHeaderColumn
                  key={header}
                  className={styles.appendUrlParamsCol}
                >
                  {header}
                </TableHeaderColumn>
              ))}
            </TableHeader>
            <TableBody>
              {rows.map(({ key, name, placement, value }) => (
                <TableRow key={key}>
                  <TableRowColumn>
                    <TechnicalText>{name}</TechnicalText>
                  </TableRowColumn>
                  <TableRowColumn>
                    <TechnicalText>{key}</TechnicalText>
                  </TableRowColumn>
                  <TableRowColumn>
                    <TechnicalText>{value}</TechnicalText>
                  </TableRowColumn>
                  <TableRowColumn>
                    {URL_PARAMETER_PLACEMENT[placement!] ||
                      NO_VALUE_PLACEHOLDER}
                  </TableRowColumn>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </SubsectionWithFallback>
      <SubsectionWithFallback
        header={TEXTS.VARIANT.ATTRS_WITH_CRITERIA_SUBS_HEADER}
        value={attributesWithCriteria}
      >
        {(value) => (
          <CodeEditor enableMouseWheel height="250px" value={value} />
        )}
      </SubsectionWithFallback>
    </>
  );
}
